module.exports = "/images/logo.png?f5db1cbbb8fbe1d780ea06a60e25b866";